import {
  SET_HEADER1_MENU_OPTIONS,
  SET_CUSTOMER_SUPPORT_DATA,
  SET_CHECK_NEW_NOTIFICATION,
  SET_CHECK_NEW_EMAIL_NOTIFICATION,
} from './constants';

import {
  SET_LOGGEDIN_USER_INFO,
  SET_NOTIFICATION_BAR_INFO,
} from 'redux/actions/global-actions';

const initialState = {
  loggedInUserInfo: {},
  customerSupportData: {
    country: [],
  },
  header1MenuOptions: {},
  checkNewNotificationExist: {},
  checkNewEmailNotificationExist: {},
  notificationBarInfo: [],
};

const layoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOGGEDIN_USER_INFO:
      return { ...state, loggedInUserInfo: action.payload };
    case SET_HEADER1_MENU_OPTIONS:
      return { ...state, header1MenuOptions: action.payload };
    case SET_CUSTOMER_SUPPORT_DATA:
      return { ...state, customerSupportData: action.payload };
    case SET_CHECK_NEW_NOTIFICATION:
      if (
        JSON.stringify(state.checkNewNotificationExist) ===
        JSON.stringify(action.payload)
      ) {
        return state;
      } else return { ...state, checkNewNotificationExist: action.payload };
    case SET_CHECK_NEW_EMAIL_NOTIFICATION:
      if (
        JSON.stringify(state.checkNewEmailNotificationExist) ===
        JSON.stringify(action.payload)
      ) {
        return state;
      } else
        return { ...state, checkNewEmailNotificationExist: action.payload };
    case SET_NOTIFICATION_BAR_INFO:
      return { ...state, notificationBarInfo: action.payload };
    default:
      return state;
  }
};

export default layoutReducer;
